import React, { useState, useEffect } from "react";
import { GoogleMap, Marker, useLoadScript, Circle } from "@react-google-maps/api";
import { MDBBtn, MDBIcon, MDBModal, MDBModalTitle, MDBModalDialog, MDBModalContent, MDBModalHeader, MDBCardTitle } from "mdb-react-ui-kit";

import { getGymCoordinates } from "../services/apiServices";
import GoogleMapComponent from "./GoogleMapComponent";

const mapContainerStyle = {
    height: "86%",
    width: "100%",
};

const defaultCenter = {
    lat: 17.43496886763314,
    lng: 78.35971199722289
};

const libraries = ["places"];

const EditLocationPopup = ({ onStatusChange, handleCoordinatesChange, access }) => {

    const frontEndEnvData = localStorage.getItem("frontEndEnvData");
    const googleMapsApiKey = frontEndEnvData ? JSON.parse(frontEndEnvData)?.googleMapsApiKey : "AIzaSyA193bF6gMmCf4nclMneNADslPE1lG_nwM";

    const [gymCoordinates, setGymCoordinates] = useState();
    const [showMapComponent, setShowMapComponent] = useState(false);
    const [fetch, setFetch] = useState(false);
    const { isLoaded, loadError } = useLoadScript({
        googleMapsApiKey: googleMapsApiKey,
        libraries,
    });


    const fetchCoordinates = async () => {
        const bid = JSON.parse(localStorage.getItem("loggedUserInfo"))?.gymid || "";
        if (!bid) {
            console.error("Gym ID is missing");
            return;
        }
        try {
            const response = await getGymCoordinates(bid);
            if (!response.ok) {
                console.error("API response error:", response.status, response.statusText);
                return;
            }
            console.log(response)

            const data = await response.json();
            setGymCoordinates(data?.gymlocation);
        } catch (error) {
            console.error("Error fetching coordinates", error);
        }
    };

    useEffect(() => {
        fetchCoordinates();

        if (fetch) {
            fetchCoordinates();
            setFetch(false);
        }
    }, [fetch]);



    const fetchgymdata = () => {
        setFetch(true)
    };


    const handleEditLocationClick = () => {
        setShowMapComponent(true);
    };

    const handleCancel = () => {
        setShowMapComponent(false);
    };

    if (loadError) return <div>Error loading maps</div>;
    if (!isLoaded) return <div>Loading Maps...</div>;

    const circleOptions = {
        strokeColor: "#00FF00",
        strokeOpacity: 0.8,
        strokeWeight: 2,
        fillColor: "#00FF00",
        fillOpacity: 0.35,
        radius: gymCoordinates?.maxdistance ?? 100
    };


    const mapCenter = gymCoordinates && typeof gymCoordinates.lat === "number" && typeof gymCoordinates.lng === "number"
        ? { lat: gymCoordinates.lat, lng: gymCoordinates.lng }
        : defaultCenter;


    return (
        <div style={{ height: "550px", overflow: "hidden" }}>
            <MDBCardTitle className="d-block mb-3">
                <div className="d-flex justify-content-between align-items-center">
                    <label>Geo Location</label>
                    {access !== 2 && <MDBIcon fas icon="edit" onClick={handleEditLocationClick} />}
                </div>

                <h6 className="checkin-radius-text d-flex location-radius mt-1">
                    {
                    // gymCoordinates?.enable ?
                        gymCoordinates?.maxdistance ? (
                            <label className="text-start">
                                <i class="fas fa-map-marked-alt me-2"></i>  Staff login radius is set to <b>{gymCoordinates?.maxdistance}</b> meters.
                            </label>
                        ) : (
                            <label className="text-start text-danger">
                                    <i class="fas fa-map-marked-alt me-2"></i>   Staff login radius not set. Please configure to enable location-based check-ins.
                                </label>
                        )
                        // : (
                        //     <label className="text-start">
                        //         <i class="fas fa-map-marked-alt me-2"></i>  Please enable geo-fence staff check-in to activate location-based check-ins.
                        //     </label>
                        // )
                    }

                </h6>
            </MDBCardTitle>
                <GoogleMap
                    center={mapCenter}
                    zoom={15}
                    mapContainerStyle={mapContainerStyle}
                    options={{
                        mapTypeControl: false,
                        streetViewControl: false,
                        fullscreenControl: false,
                        zoomControl: true,
                        draggable: false,
                        disableDefaultUI: true,
                    }}
                >
                    <>
                        <Marker
                            position={
                                gymCoordinates && typeof gymCoordinates.lat === "number" && typeof gymCoordinates.lng === "number"
                                    ? { lat: gymCoordinates.lat, lng: gymCoordinates.lng }
                                    : defaultCenter
                            }
                        />
                        {gymCoordinates && typeof gymCoordinates.lat === "number" && typeof gymCoordinates.lng === "number" && (
                            <Circle center={gymCoordinates} options={circleOptions} />
                        )}
                    </>

            </GoogleMap>
            <MDBModal open={showMapComponent} setOpen={setShowMapComponent} tabIndex="-1">
                <MDBModalDialog>
                    <MDBModalContent>
                        <MDBModalHeader>
                            <MDBModalTitle>Edit Geo Location</MDBModalTitle>
                            <MDBBtn className="btn-close" color="none" onClick={handleCancel}></MDBBtn>
                        </MDBModalHeader>

                        <GoogleMapComponent onSuccess={() => fetchgymdata()} gymCoordinatesprops={gymCoordinates} handleCancel={handleCancel} onStatusChange={onStatusChange} />

                    </MDBModalContent>
                </MDBModalDialog>
            </MDBModal>
            {/* 
            {error && (
                <MDBAlert color={error.includes("successfully") ? "success" : "danger"} position="top-center">
                    {error}
                </MDBAlert>
            )} */}
        </div>
    );
};

export default EditLocationPopup;
